import React from "react";
import {
  Container,
  Item,
  Header,
  CircleIndicator,
  Title,
  SecondaryText,
  Description,
} from "../common/CommonStyles";

export const SectionsRenderer = ({ sections, relevantIndices = [] }) => {
  if (!sections || !Array.isArray(sections) || sections.length === 0)
    return null;

  return (
    <Container>
      {sections.map((section, index) => {
        const isRelevant = relevantIndices.includes(section.index.toString());
        return (
          <Item key={index}>
            <Header isHighlighted={isRelevant}>
              <CircleIndicator isHighlighted={isRelevant}>
                {section.index}
              </CircleIndicator>
              <Title isHighlighted={isRelevant}>{section.title}</Title>
            </Header>
            <SecondaryText>{section.wiki_title}</SecondaryText>
            <Description>{section.summary}</Description>
          </Item>
        );
      })}
    </Container>
  );
};
